import { render } from "./ChannelBasicInfoSetting.vue?vue&type=template&id=13df41e8"
import script from "./ChannelBasicInfoSetting.vue?vue&type=script&lang=js"
export * from "./ChannelBasicInfoSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__